// ═══════════════════════════════════════════════════════════════════
//  modules/luckperms/LpJournal.js
//  Qui a changé quoi, quand, et ce que le serveur a répondu.
//  Une ligne par commande, groupée par lot.
// ═══════════════════════════════════════════════════════════════════

import { useEffect, useState } from "react";
import { THEME } from "../../socle/theme";
import { libelleValeur } from "./api";

export function LpJournal({ api, grades }) {
  const [lignes, setLignes] = useState([]);
  const [chargement, setChargement] = useState(true);
  const [erreur, setErreur] = useState(null);

  useEffect(() => {
    let vivant = true;
    setChargement(true);
    api.journal(300)
      .then((d) => { if (vivant) { setLignes(d); setErreur(null); } })
      .catch((e) => { if (vivant) setErreur(e.message); })
      .finally(() => { if (vivant) setChargement(false); });
    return () => { vivant = false; };
  }, [api]);

  const nomGrade = (c) => (grades.find((g) => g.cle === c) || {}).libelle || c;

  if (chargement) return <div style={{ color: THEME.textDim, padding: 24 }}>Chargement du journal…</div>;
  if (erreur) return <div style={{ color: THEME.red, padding: 24 }}>{erreur}</div>;
  if (!lignes.length)
    return (
      <div style={{ color: THEME.textDim, padding: 30, textAlign: "center" }}>
        Aucune permission n'a encore été modifiée depuis l'intranet.
      </div>
    );

  // Regroupement par lot — le serveur renvoie déjà du plus récent au plus ancien
  const lots = [];
  for (const l of lignes) {
    let lot = lots.find((x) => x.id === l.lot);
    if (!lot) {
      lot = { id: l.lot, auteur: l.auteur, date: l.applique_le, motif: l.motif, lignes: [] };
      lots.push(lot);
    }
    lot.lignes.push(l);
  }

  return (
    <div>
      {lots.map((lot) => (
        <div key={lot.id} style={{
          background: THEME.panel, border: `1px solid ${THEME.border}`,
          borderRadius: 8, marginBottom: 14, overflow: "hidden",
        }}>
          <div style={{
            display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap",
            padding: "10px 14px", background: THEME.surface,
            borderBottom: `1px solid ${THEME.border}`,
          }}>
            <b style={{ fontSize: 13.5, color: THEME.text }}>{lot.auteur || "?"}</b>
            <span style={{ color: THEME.textMuted, fontSize: 12.5 }}>
              {new Date(lot.date).toLocaleString("fr")}
            </span>
            <span style={{ color: THEME.textDim, fontSize: 12.5 }}>
              {lot.lignes.length} commande{lot.lignes.length > 1 ? "s" : ""}
            </span>
            {lot.motif ? <span style={{ color: THEME.amber, fontSize: 12.5 }}>« {lot.motif} »</span> : null}
          </div>

          {lot.lignes.map((l) => (
            <div key={l.id} style={{
              display: "flex", alignItems: "baseline", gap: 10, flexWrap: "wrap",
              padding: "6px 14px", borderBottom: `1px solid ${THEME.border}`, fontSize: 12.5,
            }}>
              <span style={{
                color: l.statut === "ok" ? THEME.emerald : l.statut === "echec" ? THEME.red : THEME.amber,
                minWidth: 74, fontWeight: 600,
              }}>
                {l.statut === "ok" ? "appliqué" : l.statut === "echec" ? "échec" : "sans effet"}
              </span>
              <code style={{ color: THEME.accent, minWidth: 220 }}>{l.node}</code>
              <span style={{ color: THEME.textMuted, minWidth: 86 }}>{nomGrade(l.grade)}</span>
              <span style={{ color: THEME.textDim }}>
                {libelleValeur(l.avant)} → <b style={{ color: THEME.text }}>{libelleValeur(l.apres)}</b>
              </span>
              {l.reponse && l.statut !== "ok" ? (
                <span style={{ color: THEME.textDim, flexBasis: "100%", paddingLeft: 84 }}>{l.reponse}</span>
              ) : null}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
